module.exports = __webpack_public_path__ + "img/SlideShow04.49bcb011.jpg";